module.exports = __webpack_public_path__ + "img/image001.30706272.jpg";